var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _g2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagKh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#032ea1;}.cls-2{fill:#e00025;}.cls-10,.cls-11,.cls-3,.cls-4,.cls-5,.cls-6,.cls-9{fill:#fff;}.cls-10,.cls-11,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;}.cls-3,.cls-4,.cls-9{stroke-linejoin:bevel;}.cls-3,.cls-5,.cls-8{stroke-width:1.54px;}.cls-4{stroke-width:1.51px;}.cls-10,.cls-11,.cls-5,.cls-6,.cls-7,.cls-8{stroke-miterlimit:6.4;}.cls-6{stroke-width:1.57px;}.cls-7,.cls-8{fill:none;}.cls-7{stroke-width:1.28px;}.cls-9{stroke-width:1.65px;}.cls-10{stroke-width:1.67px;}.cls-11{stroke-width:1.67px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag-kh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0H1000V640H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,160H1000V480H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.86,300H591.94v70.06H409.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M582.55,338.68h5.73v26.39h-5.73Zm-172.69-13H591.94v8.14H409.86Zm0-11H591.94v7.18H409.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M409.86,303.58H591.94v7H409.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M457.8,338.68h5.73v26.39H457.8Zm78.38,0h5.74v26.39h-5.74Zm-124.88,0H417v26.39H411.3Zm11.25,0h5.73v26.39h-5.73Zm12,0h5.73v26.39h-5.73Zm12,0h5.73v26.39h-5.73Zm100.51,0h5.74v26.39h-5.74Zm12,0h5.74v26.39h-5.74Zm12,0h5.74v26.39h-5.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M338.64,373.74a15,15,0,0,0,7.08-8.52H654.63a15,15,0,0,0,7.08,8.52Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M496.23,193.34s-.23-6.58,3.6-6.66,3.6,6.66,3.6,6.66Zm-20,87.26v-8.86c-.12-4.43-4.41-4.75-4.54-8,0,0-.55-4.84.73-7.05,1.73,6.48,4.89,5.29,4.89,2.63,0-2.33-1.79-4.49-5.46-10.13-1.17-1.81-.45-7.46,1.2-9.48.63,4.91,1.36,7.26,3.47,7.26,1.29,0,2.34-.83,2.34-3.29,0-3.14-2.12-4.72-3.16-7.56a8,8,0,0,1,1.64-8.61c.86,4.85.61,6.78,2.76,6.78,4.34-1.38,0-7.66-.93-9.25-1.06-1.84,1.44-5.53,1.44-5.53,1.38,4.3,1.82,4.65,3.31,4.25,1.88-.5,1.64-3.29-.66-5.54-1.44-1.42-1.29-3.54.26-5.24,1.56,3.05,3.56,2.87,3.75,1.06L486,207h27.61l-1.37,6.8c-.39,1.94,2.23,2.37,3.86-.82,1.56,1.7,1.71,3.81.26,5.23-2.29,2.26-2.53,5-.65,5.55,1.49.4,1.93,0,3.31-4.26a6.54,6.54,0,0,1,1.43,5.54c-.92,1.58-5.26,7.87-.92,9.24,2.15,0,1.89-1.93,2.76-6.78a8,8,0,0,1,1.64,8.61c-1,2.85-3.16,4.43-3.16,7.56,0,2.46,1.05,3.3,2.33,3.3,2.12,0,2.84-2.36,3.48-7.27,1.64,2,2.37,7.67,1.19,9.48-3.66,5.64-5.45,7.8-5.45,10.13,0,2.66,3.15,3.85,4.89-2.63,1.28,2.21.72,7.05.72,7.05-.12,3.23-4.41,3.55-4.54,8v8.86ZM487.8,207l-.64-5H512.5l-.63,5Zm1.69-5.11-.54-4.11h21.76l-.54,4.11Zm3.46-4.25-.37-4.11h14.5l-.36,4.11Zm52.83,176.13c-3.24-1.25-8-4.68-8-8.12V326.75l4.22-5.37H457.6l4,5.37v38.88c0,3.44-3.24,6.86-6.48,8.11Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M472.61,338.68h5.74v26.39h-5.74Zm48.51,0h5.74v26.39h-5.74Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M456.08,277.13v44.25h86.44v-9.53l.12-34.72a6.7,6.7,0,0,0-4.15,4.59v18.84h-78V281.72a7.5,7.5,0,0,0-4.41-4.59Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M530.79,373.74c-2.83-1.25-9-4.68-9-8.12v-43.5c.6-2.43,3.9-3.86,6-5.37H470.51c2.73,1.44,5.77,2.64,6.85,5.37v43.51c0,3.44-4.86,6.86-7.68,8.11Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M538.48,317.21V285.87h-7.85v-3.06H468.48v3.06h-7.85v31.34ZM518.4,373.74c-2.76-1.25-6.8-4.68-6.8-8.12V328.48l2.28-3.37H485.57l2.28,3.37v37.15c0,3.44-4,6.86-6.8,8.11Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M492.56,325.11h14.35v48.6H492.56Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M514.44,314.42c0-3.2,9.34-3.34,14.13-6.07H471c4.79,2.73,13.88,2.95,13.88,6.07l1.95,6.21,23.81,1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M525.68,280.6c0-7.84.33-10.86,2.74-10.86v24.93c-5.9,2.14-10.12,9.68-10.12,9.68H481.16S477,296.81,471,294.67V269.74c3,0,3,3.16,3,10.86Zm2.74-3.22c0-9,7.76-10,7.76-10v8c-2.95-.12-4.38,2.53-4.38,6.47s2.38,4,2.38,4v22.71h-5.76Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M471.08,277.38c0-9-7.76-10-7.76-10v8c2.95-.12,4.37,2.53,4.37,6.47s-2.38,4-2.38,4v22.71h5.76Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M486.37,215.45h27.41M483.12,224H516.6m-36.72,10.38h39.84m-43.24,12.69h47.26M475.4,261.54h48.68"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M460.63,308.73h77.85m-53.15,0h28.86v10.61H485.33Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M481.72,285.24c4.78,5.74,4.34,15.49,4.28,21.23h27.75c-.06-5.74-.5-15.49,4.29-21.23Zm15.6-65.81-3.81-2v-5.59c1.56.46,3.3.65,3.47,3.13.54-3.54,1.52-3.36,3-4.74,1.53,1.38,2.51,1.2,3.05,4.74.17-2.48,1.92-2.67,3.47-3.14v5.6l-3.8,2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M497.06,228.62l-6.31-4.35v-5.15c2.21.51,4.69.72,4.94,3.44.77-3.88,2.16-5.88,4.34-7.39,2.18,1.51,3.57,3.51,4.34,7.39.25-2.72,2.73-2.93,4.95-3.44v5.15L503,228.62Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M496.61,242.94l-7.26-6.38V229c2.54.75,5.4,1.06,5.68,5.05.89-5.69,2.49-8.64,5-10.86,2.51,2.22,4.11,5.16,5,10.86.28-4,3.14-4.3,5.68-5.05v7.57l-7.26,6.38ZM510,251.4l-6.56,9.08H496l-6.56-9.08Zm-24.35,15.25c3.29,1.79,4.5,5.37,4.85,12.08H509c.35-6.71,1.56-10.29,4.85-12.08Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M514.1,251.4v-9.12a8.34,8.34,0,0,0-6,5.21c0-3-4-10-8.33-13.49-4.36,3.89-8.41,10.21-8.33,13.49-.74-2.39-2.92-4.35-6-5.21v9.12Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M515.49,266.65v-9.13c-3.42.86-5.63,2.71-6.62,5.22,0-3-4.37-10-9.13-13.49-4.78,3.89-9.22,10.21-9.14,13.49-.81-2.39-3.2-4.35-6.62-5.22v9.13Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M519.33,285.37V274.84a15.25,15.25,0,0,0-8.24,6.08c0-5.69-6.43-14.38-11.36-17.22-5.05,2.92-11.36,11.89-11.36,17.22-1.37-1.82-4-5-8.24-6.08v10.53Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M517,308.73V297.91c-3.76,1.47-4.88,5.09-6.06,7.55.46-11-6.18-22.77-11.24-25.76-5.06,3-11.83,15-11.24,25.76-1.21-2.45-2.3-6.08-6.05-7.55v10.82Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M514.4,325.11V314.29c-3.93.94-4.17,2.39-5.42,4.81.46-6.55-4.18-14-9.24-17-5.06,3-9.7,10.47-9.24,17-1.25-2.42-1.4-3.87-5.42-4.81v10.82Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M345.72,365.22v-32.7c-1.07-4.17-4.6-7.85-7.26-8.59V295.14l6,3.24,6.84,30.1v36.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M345.72,365.35V332.52c-1.07-4.16-4.6-7.85-7.26-8.58V293.15c4,0,6,5.23,6,5.23l6.84,30.1V365.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.47,373.74c2.77-1.25,6.8-4.68,6.8-8.12V324.75l-1.9-3.37H416l-2.71,3.37v40.87c0,3.44,2.77,6.87,5.53,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M404.77,373.74c-2.77-1.25-6.8-4.68-6.8-8.12V326.75l5.79-5.38H356.42l5.79,5.37v38.87c0,3.44-4,6.87-6.8,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M398.13,373.74c-2.77-1.25-6.8-4.68-6.8-8.12V330.48l3.79-5.38H365.05l3.79,5.38v35.14c0,3.44-4,6.87-6.8,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372.9,325.11h14.37v48.63H372.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.35,338.68h5.73v26.39h-5.73Zm49.2,0h5.73v26.39h-5.73Zm-54.1-44.51h6.91v27.05h-6.91Zm0-5.09h6.87v5h-6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M405.3,300h9.86v20.89H405.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M355.25,321V274.71c2,0,2.28,6.79,6.8,6.79,2.35,0,2.1-2.81.78-5.1-1.17-2-2.62-4.83-.65-10,1.35,4,5,5.26,4.31,2.76-1.15-4.31-4.47-5-2-11.69.86,5.57,4.44,5.33,3.57,2.09-1-3.65-3-5.14-.51-10.29,1.4,5.84,3.29,5.5,3.29,1.88,0-5.36-.21-11.13,6.72-13.28,0,0,.4-4.91,2.9-4.91s2.9,4.91,2.9,4.91c6.93,2.15,6.72,7.92,6.72,13.28,0,3.62,1.89,4,3.29-1.87,2.49,5.14.47,6.63-.51,10.28-.87,3.24,2.71,3.48,3.57-2.09,2.49,6.68-.83,7.39-2,11.69-.67,2.5,3,1.23,4.31-2.76,2,5.22.52,8-.65,10-1.33,2.29-1.58,5.1.78,5.1,4.52,0,4.83-6.79,6.8-6.79V321Zm-10.82-35v35.33h4V286a3.53,3.53,0,0,0-4,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M344.55,308.9c5,2.55,9.91,5.5,11.16,12.47H344.55Zm69.07-10.57v23.05h3.26V298.27A3.44,3.44,0,0,0,413.62,298.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M416.88,308.73c-5,2.54-9.91,5.49-11.16,12.47h11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M384,254.89l2.9-2.44v-3.13a3.1,3.1,0,0,0-2.43,1.5,8,8,0,0,0-4.1-4.69,7.87,7.87,0,0,0-4.1,4.62,3,3,0,0,0-2.42-1.43v3.13l2.9,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M385.51,262.71l1.35-2.92v-4.06a3,3,0,0,0-2.43,1.52,8.1,8.1,0,0,0-4.1-4.76,8,8,0,0,0-4.1,4.68,3,3,0,0,0-2.43-1.44v4.06l1.36,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M385.72,273.32l4.31-5.26v-5.19c-1.58.18-2.44.81-3.61,2.57-1-3.55-3.16-4.33-6.09-6.06-2.92,1.73-5.09,2.38-6.09,5.93-1.16-1.76-2-2.26-3.6-2.44v5.19l4.31,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M387,283.74s5-4.39,5.32-6.79V271.4a6.31,6.31,0,0,0-5.22,3c-1.23-4.59-3.14-5.87-6.74-8.1-3.61,2.23-5.52,3.51-6.74,8.1a6.33,6.33,0,0,0-5.23-3v5.54c.63,2.41,5.32,6.79,5.32,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M389.12,303s6.88-7.62,7-10.59v-8.65c-2.57.36-5,2.13-6.91,5.68-1.62-7.16-4.14-12.15-8.91-15.62-4.77,3.47-7.3,8.46-8.91,15.62-1.91-3.55-4.34-5.32-6.92-5.68v8.65c.49,3,7,10.59,7,10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M389.12,314.34s5.88-6,7-8.58v-8.65c-2.57.36-5,2.13-6.91,5.68-1.62-7.16-4.14-11.26-8.91-14.73-4.77,3.47-7.3,7.57-8.91,14.73-1.91-3.56-4.34-5.33-6.92-5.68v8.65c1.49,2.59,7,8.58,7,8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M391.49,321c-1.72-7.47-3.19-13-11.46-18.62-8.27,5.61-9.74,11.15-11.46,18.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.75,325.11V314.29c-3.76,1.47-7.15,3.65-8.4,6.07-1.4-6-4.09-8.65-7.45-12.28-3.35,3.63-5.6,6.28-7,12.28-1.25-2.42-4.64-4.6-8.4-6.07v10.82Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a-2",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M654.32,365.22v-32.7c1.07-4.17,4.6-7.85,7.26-8.59V295.14l-6,3.24-6.84,30.1v36.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M654.32,365.35V332.52c1.07-4.16,4.6-7.85,7.26-8.58V293.15c-4,0-6,5.23-6,5.23l-6.84,30.1V365.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M658.57,373.74c-2.77-1.25-6.8-4.68-6.8-8.12V324.75l1.9-3.37H584l2.72,3.37v40.87c0,3.44-2.77,6.87-5.54,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.27,373.74c2.77-1.25,6.8-4.68,6.8-8.12V326.75l-5.79-5.38h47.34l-5.8,5.37v38.87c0,3.44,4,6.87,6.8,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M601.91,373.74c2.77-1.25,6.8-4.68,6.8-8.12V330.48l-3.79-5.38H635l-3.79,5.38v35.14c0,3.44,4,6.87,6.8,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M627.14,325.11H612.77v48.63h14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M646.69,338.68H641v26.39h5.74Zm-49.2,0h-5.74v26.39h5.74Zm54.1-44.51h-6.91v27.05h6.91Zm0-5.09h-6.87v5h6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M594.74,300h-9.86v20.89h9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M644.79,321V274.71c-2,0-2.28,6.79-6.8,6.79-2.35,0-2.11-2.81-.78-5.1,1.17-2,2.62-4.83.65-10-1.35,4-5,5.26-4.31,2.76,1.15-4.31,4.47-5,2-11.69-.87,5.57-4.44,5.33-3.57,2.09,1-3.65,3-5.14.51-10.29-1.4,5.84-3.29,5.5-3.29,1.88,0-5.36.21-11.13-6.72-13.28,0,0-.4-4.91-2.9-4.91s-2.9,4.91-2.9,4.91c-6.93,2.15-6.73,7.92-6.73,13.28,0,3.62-1.88,4-3.28-1.87-2.49,5.14-.47,6.63.51,10.28.87,3.24-2.71,3.48-3.57-2.09-2.49,6.68.83,7.39,2,11.69.67,2.5-3,1.23-4.31-2.76-2,5.22-.52,8,.65,10,1.32,2.29,1.57,5.1-.78,5.1-4.52,0-4.83-6.79-6.8-6.79V321Zm10.82-35v35.33h-4V286a3.53,3.53,0,0,1,4,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M655.49,308.9c-5,2.55-9.92,5.5-11.16,12.47h11.16Zm-69.07-10.57v23.05h-3.26V298.27A3.44,3.44,0,0,1,586.42,298.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.16,308.73c5,2.54,9.91,5.49,11.16,12.47H583.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M616.08,254.89l-2.9-2.44v-3.13a3.1,3.1,0,0,1,2.43,1.5,8,8,0,0,1,4.1-4.69,7.91,7.91,0,0,1,4.1,4.62,3,3,0,0,1,2.42-1.43v3.13l-2.9,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M614.53,262.71l-1.35-2.92v-4.06a3.05,3.05,0,0,1,2.43,1.52,8.1,8.1,0,0,1,4.1-4.76,8,8,0,0,1,4.1,4.68,3,3,0,0,1,2.42-1.44v4.06l-1.35,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M614.32,273.32,610,268.06v-5.19c1.58.18,2.44.81,3.6,2.57,1-3.55,3.17-4.33,6.09-6.06,2.92,1.73,5.1,2.38,6.09,5.93,1.17-1.76,2-2.26,3.6-2.44v5.19l-4.31,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M613.06,283.74s-5-4.39-5.32-6.79V271.4a6.33,6.33,0,0,1,5.22,3c1.23-4.59,3.14-5.87,6.74-8.1,3.61,2.23,5.52,3.51,6.74,8.1a6.33,6.33,0,0,1,5.23-3v5.54c-.63,2.41-5.32,6.79-5.32,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M610.92,303s-6.88-7.62-7-10.59v-8.65c2.57.36,5,2.13,6.91,5.68,1.62-7.16,4.14-12.15,8.91-15.62,4.77,3.47,7.3,8.46,8.91,15.62,1.91-3.55,4.34-5.32,6.92-5.68v8.65c-.5,3-7,10.59-7,10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M610.92,314.34s-5.89-6-7-8.58v-8.65c2.57.36,5,2.13,6.91,5.68,1.62-7.16,4.14-11.26,8.91-14.73,4.77,3.47,7.3,7.57,8.91,14.73,1.91-3.56,4.34-5.33,6.92-5.68v8.65c-1.5,2.59-7,8.58-7,8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M608.55,321c1.71-7.47,3.19-13,11.46-18.62,8.27,5.61,9.74,11.15,11.46,18.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M604.29,325.11V314.29c3.75,1.47,7.15,3.65,8.4,6.07,1.4-6,4.09-8.65,7.44-12.28,3.36,3.63,5.6,6.28,7,12.28,1.26-2.42,4.65-4.6,8.4-6.07v10.82Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M330.49,373.3v9.88h339V373.3Zm-6.14,10v12.88H675.64V383.27Zm351.29,12.88-351.29.1-10.27-.1v17H685.92v-17Zm-371.9,17.11v20H696.27v-20Zm392.53,20v0H303.74v0H293.39v20H706.61v-20Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M367.28,373.35h25.61v79.9H367.28Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M373,373.35h14.26v79.9H373Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M486.76,373.35h25.6v79.9h-25.6Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M492.6,373.35h14.26v79.9H492.6Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M606.93,373.35h25.61v79.9H606.93Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M612.6,373.35h14.26v79.9H612.6Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M345.72,365.22H654.64m-281.95,78h14.79m-14.79-10h14.79m-14.79-10h14.79m-14.79-10h14.79m-14.79-10h14.79m-14.79-10h14.79m-14.79-10h14.79m105.18,60h13.77m-13.77-10h13.77m-13.77-10h13.77m-13.77-10h13.77m-13.77-10h13.77m-13.77-10h13.77m-13.77-10h13.77m105.91,60h14.79m-14.79-10h14.79m-14.79-10h14.79m-14.79-10h14.79m-14.79-10h14.79m-14.79-10h14.79m-14.79-10h14.79"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKh);
export default __webpack_public_path__ + "static/media/flag-kh.da3712e0e9b0ae78a2ddc29a51e402ad.svg";
export { ForwardRef as ReactComponent };